import type { ChangePasswordReason } from 'shared/api/auth/enums';

// Constants.
export const TEMP_ACCESS_TOKEN_KEY = 'tempAccessToken';
export const PASSWORD_CHANGE_REASON_KEY = 'passwordChangeReason';

export const TokenManager = {
  getToken: (): string | null => localStorage.getItem('token'),

  saveToken: (token: string): void => {
    localStorage.setItem('token', token);
  },

  removeToken: () => localStorage.removeItem('token'),

  getRefreshToken: (): string | null => localStorage.getItem('refresh'),

  saveRefreshToken: (token: string): void => {
    localStorage.setItem('refresh', token);
  },

  removeRefreshToken: () => localStorage.removeItem('refresh'),
};

export const TempAccessTokenManager = {
  save: (token: string): void =>
    sessionStorage.setItem(TEMP_ACCESS_TOKEN_KEY, token),

  get: (): string | null => sessionStorage.getItem(TEMP_ACCESS_TOKEN_KEY),

  remove: () => sessionStorage.removeItem(TEMP_ACCESS_TOKEN_KEY),
};

export const PasswordChangeReasonManager = {
  save: (reason: ChangePasswordReason): void =>
    sessionStorage.setItem(PASSWORD_CHANGE_REASON_KEY, reason),

  get: (): ChangePasswordReason | null =>
    sessionStorage.getItem(
      PASSWORD_CHANGE_REASON_KEY,
    ) as ChangePasswordReason | null,

  remove: () => sessionStorage.removeItem(PASSWORD_CHANGE_REASON_KEY),
};
